import { LOGOUT_PATH } from 'routing/routes/auth/constants';
/**
 * Returns the first available path from the sidebarItems list based on the user's permissions.
 * If no path is available, defaults to logout.
 * @param pathItems - list of paths to check
 * @param permissions - list of user permissions
 */
export var getAvailableRedirectPath = function getAvailableRedirectPath(pathItems, permissions) {
    var _path$url;
    var userPermissions = permissions.map(function (_ref) {
        var identifier = _ref.identifier;
        return identifier;
    });
    var path = pathItems.find(function (item) {
        if (Array.isArray(item.permission)) {
            return userPermissions.some(function (el) {
                return item.permission.includes(el);
            });
        }
        return item.permission ? userPermissions.includes(item.permission) : true;
    });
    return (_path$url = path === null || path === void 0 ? void 0 : path.url) !== null && _path$url !== void 0 ? _path$url : LOGOUT_PATH;
};
